import React, {useEffect, useState} from "react";
import {TextField} from "@mui/material";

const vinRegex = /^[A-HJ-NPR-Z0-9]{17}$/;
const frameRegex = /^[A-Z0-9]{3,6}([- ]?[A-Z0-9]{5,8})$/;

export function VinCodeInput({handle, val, disabled = false}) {
    const [vin, setVin] = useState(val ? val : "");
    const [error, setError] = useState(false);
    const [frameVin, setFrameVin] = useState("VIN/Frame");
    useEffect(() => {
        if (!vin) {
            setFrameVin('VIN/Frame');
            handle(null)
        }
        if (vin) {
            handle(vin)
        }
    }, [error, vin]);

    const handleChange = (e) => {
        const value = e.target.value.toUpperCase();
        const dashIndex = value.indexOf('-');
        if (!(dashIndex >= 3 && dashIndex <= 6)) {
            // запрещенные буквы заменяем сразу
            const sanitized = value.replace(/[IOQ]/gi, "");
            setVin(sanitized);
            setFrameVin("VIN");
            // валидация
            setError(!(vinRegex.test(sanitized)));
        } else {
            setError(!frameRegex.test(value));
            setFrameVin("Frame");
            setVin(value);
        }
    };

    return (<TextField
        label={!disabled ? `Введите ${frameVin}` : frameVin}
        value={vin}
        onChange={handleChange}
        fullWidth
        disabled={disabled}
        size="small"
       // inputProps={{maxLength: 17}}
       // error={error && vin.length > 0}
        helperText={error ? `Возможно, введен неверный VIN/Frame` : ""}
    />);
}
